/* eslint-disable no-unused-vars */
import { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import useLoader from "./useLoader"; // Ajuste o caminho conforme sua estrutura

/**
 * Hook customizado que estende o useQuery para gerenciar um Loader global.
 * @param {Object} queryOptions - Opções padrão do useQuery (queryKey, queryFn, enabled, etc.)
 */
const useQueryWithLoader = (queryOptions) => {
  const { showGlobalLoader = true, ...restOptions } = queryOptions;
  const { showLoader, hideLoader } = useLoader();

  const refetchWhen = queryOptions?.refetchWhen ?? false;

  const query = useQuery(queryOptions);

  // Ref para garantir que esta instância do hook saiba se ela "ativou" um loader
  const amILoading = useRef(false);

  useEffect(() => {
    if (!showGlobalLoader) return;
    // Se a query está buscando e eu ainda não incrementei o loader
    if (query.isFetching && !amILoading.current) {
      showLoader();
      amILoading.current = true;
    }

    // Se a query parou de buscar e eu tinha incrementado o loader
    if (!query.isFetching && amILoading.current) {
      hideLoader();
      amILoading.current = false;
    }

    // Cleanup: Se o usuário sair da página com a query pendente
    return () => {
      if (amILoading.current) {
        hideLoader();
        amILoading.current = false;
      }
    };
  }, [query.isFetching, showLoader, hideLoader, showGlobalLoader]);

  useEffect(() => {
    if (typeof refetchWhen === "function") {
      const value = refetchWhen();
      if (value) {
        query.refetch();
      }
    }
  }, [refetchWhen, query.refetch, query]);

  return query;
};

export default useQueryWithLoader;
